import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FormEntry from '../../../models/FormEntry'
import { Divider, Form, Grid, Header, List, Table } from 'semantic-ui-react'
import Section from '../Inputs/Section'
import Input from '../Inputs/Input'
import { observer } from 'mobx-react'
import { runInAction } from 'mobx'
import Checkbox from '../Inputs/Checkbox'
import Select from '../Inputs/Select'
import { DispositifList } from '../../../utils/FormSelectHelper'
import TableDnD from '../Inputs/TableDnD'

@observer
class RIA537000E extends Component {
  static propTypes = {
    equipment: PropTypes.instanceOf(FormEntry)
  }

  tableList = [
    'qtyAG',
    'qtyAF',
    'qtyCC10',
    'qtyCL',
    'qtyCL6',
    'qtyCL10',
    'qtyCONT',
    'qtyRHT',
    'qtyDFI',
    'qtyDFP',
    'qtyDC',
    'qtyDUV',
    'qtyHT',
    'qtyDA',
    'qtyS',
    'qtyHP',
    'qtySP',
    'qtyID',
    'qtyIBP',
    'qtyIHP',
    'qtyIV',
    'qtyIPL',
    'qtyMR',
    'qtyIPA',
    'qtyPS',
    'qtyRV',
    'qtyKP',
    'qtyMAD',
    'qtyISO',
    'qtyPAI',
    'qtyANN',
    'qtyPAR',
    'qtyPZ2',
    'qtyPZ',
    'qtyRP',
    'qtyRelais',
    'qtyRFL',
    'qtyK',
    'qtySOL',
    'qtyA',
    'qtySM',
    'qtyTEL',
    'qtyBOOS'
  ]

  handleUpdateRegistryCount = () => {
    const { equipment } = this.props
    let newValue = 0
    for (const name of this.tableList) {
      const fieldValue = parseInt(equipment.getValue(name))
      if (Number.isInteger(fieldValue)) {
        newValue += fieldValue
      }
    }
    runInAction(() => {
      equipment.updateValue('totalEquipment', newValue)
    })
  }

  handleUpdateRegistryFromTableCount = () => {
    const { equipment } = this.props
    const rows = parseInt(equipment.getValue('tableRows', false, 0))
    const countValues = {}
    for (let i = 0; i < rows; i++) {
      const value = equipment.getValue(`dispositif_${i}`)
      if (value) {
        if (countValues[value] === undefined) { countValues[value] = 0 }
        countValues[value]++
      }
    }
    for (const [key, value] of Object.entries(countValues)) {
      runInAction(() => {
        equipment.updateValue(`qty${key}`, value)
      })
    }
    this.handleUpdateRegistryCount()
  }

  render () {
    const { equipment } = this.props
    return (
      <Form>
        <Section title={(<Header as='h2'>VÉRIFICATION SECTORIELLE ÉQUIPEMENTS (CAN/ULC S537)</Header>)}>
          <Form.Group widths='equal'>
            <Input name='modelePanneau' formEntry={equipment} label='Modèle panneau' />
            <Input name='uneDeuxEtapes' formEntry={equipment} label='Une ou deux étapes' />
          </Form.Group>
        </Section>
        <Section title={(<Header as='h2'>REGISTRE DES ÉQUIPEMENTS</Header>)}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={2}>
                <Header as='h5'>DISPOSITIF</Header>
              </Grid.Column>
              <Grid.Column width={12}>
                <Header as='h5'>DESCRIPTION</Header>
              </Grid.Column>
              <Grid.Column width={2}>
                <Header as='h5'>QUANTITÉ</Header>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>AG</Grid.Column>
              <Grid.Column width={12}>Alarme générale</Grid.Column>
              <Grid.Column width={2}><Input name='qtyAG' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>AF</Grid.Column>
              <Grid.Column width={12}>Avertisseur de fumée</Grid.Column>
              <Grid.Column width={2}><Input name='qtyAF' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>CC10</Grid.Column>
              <Grid.Column width={12} />
              <Grid.Column width={2}><Input name='qtyCC10' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>CL</Grid.Column>
              <Grid.Column width={12}>Cloche</Grid.Column>
              <Grid.Column width={2}><Input name='qtyCL' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>CL6</Grid.Column>
              <Grid.Column width={12}>Cloche 6"</Grid.Column>
              <Grid.Column width={2}><Input name='qtyCL6' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>CL10</Grid.Column>
              <Grid.Column width={12}>Cloche 10"</Grid.Column>
              <Grid.Column width={2}><Input name='qtyCL10' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>CONT</Grid.Column>
              <Grid.Column width={12}>Contact sec</Grid.Column>
              <Grid.Column width={2}><Input name='qtyCONT' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>RHT</Grid.Column>
              <Grid.Column width={12}>Détecteur de chaleur thermovélocimétrique (température variable)</Grid.Column>
              <Grid.Column width={2}><Input name='qtyRHT' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>DFI</Grid.Column>
              <Grid.Column width={12}>Détecteur de fumée à ionisation</Grid.Column>
              <Grid.Column width={2}><Input name='qtyDFI' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>DFP</Grid.Column>
              <Grid.Column width={12}>Détecteur de fumée à photo électrique</Grid.Column>
              <Grid.Column width={2}><Input name='qtyDFP' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>DC</Grid.Column>
              <Grid.Column width={12}>Détecteur de fumée de conduit</Grid.Column>
              <Grid.Column width={2}><Input name='qtyDC' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>DUV</Grid.Column>
              <Grid.Column width={12}>Détecteur ultraviolet d'étincelle</Grid.Column>
              <Grid.Column width={2}><Input name='qtyDUV' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>HT</Grid.Column>
              <Grid.Column width={12}>Détecteurs de chaleur thermostatique (fixe)</Grid.Column>
              <Grid.Column width={2}><Input name='qtyHT' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>DA</Grid.Column>
              <Grid.Column width={12}>Dispositif auxiliaire</Grid.Column>
              <Grid.Column width={2}><Input name='qtyDA' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>S</Grid.Column>
              <Grid.Column width={12}>Dispositif de signalisation visuelle</Grid.Column>
              <Grid.Column width={2}><Input name='qtyS' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>HP</Grid.Column>
              <Grid.Column width={12}>Haut-parleur</Grid.Column>
              <Grid.Column width={2}><Input name='qtyHP' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>SP</Grid.Column>
              <Grid.Column width={12}>Haut-parleur à cône</Grid.Column>
              <Grid.Column width={2}><Input name='qtySP' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>ID</Grid.Column>
              <Grid.Column width={12}>Interrupteur de débit des gicleurs</Grid.Column>
              <Grid.Column width={2}><Input name='qtyID' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>IBP</Grid.Column>
              <Grid.Column width={12}>Interrupteur de surveillance de basse pression des gicleurs</Grid.Column>
              <Grid.Column width={2}><Input name='qtyIBP' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>IHP</Grid.Column>
              <Grid.Column width={12}>Interrupteur de surveillance de haute pression des gicleurs</Grid.Column>
              <Grid.Column width={2}><Input name='qtyIHP' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>IV</Grid.Column>
              <Grid.Column width={12}>Interrupteur de surveillance de valve des gicleurs</Grid.Column>
              <Grid.Column width={2}><Input name='qtyIV' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>IFL</Grid.Column>
              <Grid.Column width={12}>Interrupteur faisceau lumineux de supervision cylindre</Grid.Column>
              <Grid.Column width={2}><Input name='qtyIPL' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>M/R</Grid.Column>
              <Grid.Column width={12}>Interrupteur maître / réserve</Grid.Column>
              <Grid.Column width={2}><Input name='qtyMR' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>IPA</Grid.Column>
              <Grid.Column width={12}>Interrupteur pneumatique d'alarme (Pressostat)</Grid.Column>
              <Grid.Column width={2}><Input name='qtyIPA' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>PS</Grid.Column>
              <Grid.Column width={12}>Interrupteur pneumatique de supervision de pression (Pressostat)</Grid.Column>
              <Grid.Column width={2}><Input name='qtyPS' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>KV</Grid.Column>
              <Grid.Column width={12}>Klaxon et signal visuel combinés</Grid.Column>
              <Grid.Column width={2}><Input name='qtyRV' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>KP</Grid.Column>
              <Grid.Column width={12}>Klaxon pneumatique</Grid.Column>
              <Grid.Column width={2}><Input name='qtyKP' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>MAD</Grid.Column>
              <Grid.Column width={12}>Module adressable</Grid.Column>
              <Grid.Column width={2}><Input name='qtyMAD' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>ISO</Grid.Column>
              <Grid.Column width={12}>Module d'isolation en cas de défaut</Grid.Column>
              <Grid.Column width={2}><Input name='qtyISO' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>PAI</Grid.Column>
              <Grid.Column width={12}>Panneau d'alarme incendie</Grid.Column>
              <Grid.Column width={2}><Input name='qtyPAI' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>ANN</Grid.Column>
              <Grid.Column width={12}>Annonciateur</Grid.Column>
              <Grid.Column width={2}><Input name='qtyANN' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>PAR</Grid.Column>
              <Grid.Column width={12}>Panneau d'alarme pour relâche</Grid.Column>
              <Grid.Column width={2}><Input name='qtyPAR' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>PZ2</Grid.Column>
              <Grid.Column width={12}>Piezo silencable</Grid.Column>
              <Grid.Column width={2}><Input name='qtyPZ2' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>PZ</Grid.Column>
              <Grid.Column width={12}>Piezzo</Grid.Column>
              <Grid.Column width={2}><Input name='qtyPZ' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>RP</Grid.Column>
              <Grid.Column width={12}>Relâche pneumatique</Grid.Column>
              <Grid.Column width={2}><Input name='qtyRP' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>Relais</Grid.Column>
              <Grid.Column width={12}>Relais</Grid.Column>
              <Grid.Column width={2}><Input name='qtyRelais' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>RFL</Grid.Column>
              <Grid.Column width={12}>Résistance fin de ligne</Grid.Column>
              <Grid.Column width={2}><Input name='qtyRFL' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>K</Grid.Column>
              <Grid.Column width={12}>Sirène du type klaxon</Grid.Column>
              <Grid.Column width={2}><Input name='qtyK' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>SOL</Grid.Column>
              <Grid.Column width={12}>Solénoide</Grid.Column>
              <Grid.Column width={2}><Input name='qtySOL' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>A</Grid.Column>
              <Grid.Column width={12}>Station d'avortement</Grid.Column>
              <Grid.Column width={2}><Input name='qtyA' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>SM</Grid.Column>
              <Grid.Column width={12}>Station manuelle</Grid.Column>
              <Grid.Column width={2}><Input name='qtySM' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>TEL</Grid.Column>
              <Grid.Column width={12}>Téléphone d'urgence</Grid.Column>
              <Grid.Column width={2}><Input name='qtyTEL' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>BOOS</Grid.Column>
              <Grid.Column width={12}>Booster</Grid.Column>
              <Grid.Column width={2}><Input name='qtyBOOS' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={14} verticalAlign='middle'><Header as='h4'>TOTAL</Header></Grid.Column>
              <Grid.Column width={2}><Input name='totalEquipment' formEntry={equipment} size='mini' /></Grid.Column>
            </Grid.Row>
          </Grid>
          <List bulleted>
            <List.Item>Les essais indiqués sur ce formulaire peuvent ne pas comprendre l'essai ou le fonctionnement des dispositifs auxiliaires</List.Item>
            <List.Item>Les avertisseurs de fumée autonomes ne font pas partie du réseau avertisseur d'incendie mais leur mise à l'essai peut être exigée par l'autorité compétente.</List.Item>
          </List>
        </Section>
        <Section title={(<Header as='h2'>RAPPORT DE VÉRIFICATION SECTORIELLE (ÉQUIPEMENTS)<br />DU RÉSEAU AVERTISSEUR D'INCENDIE<br />(Normes CAN/ULC-S537)</Header>)}>
          <Input name='designationSystem' formEntry={equipment} label='Désignation du système' />
          <Divider />
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={12}><Header as='h5'>Fonctionnement</Header></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapportFonctionnementUneEtape' formEntry={equipment} label='Une étape' /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapportFonctionnementDeuxEtapes' formEntry={equipment} label='Deux étapes' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={12}><Header as='h5'>Communication phonique</Header></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapportCommunicationPhoniqueOui' formEntry={equipment} label='Oui' /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapportCommunicationPhoniqueNon' formEntry={equipment} label='Non' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={12}><Header as='h5'>Système adressable</Header></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapportSystemAdressableOui' formEntry={equipment} label='Oui' /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapportSystemAdressableNon' formEntry={equipment} label='Non' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={12}><Header as='h5'>Système semi-adressable</Header></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapportSystemSemiAdressableOui' formEntry={equipment} label='Oui' /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapportSystemSemiAdressableNon' formEntry={equipment} label='Non' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={16}><Checkbox name='rapportValidation' formEntry={equipment} label='La présente certifie que les équipements incendie ajoutés ont été vérifiés conformément à la norme CAN/ULC-S537, et sont présentement fonctionnels.' /></Grid.Column>
            </Grid.Row>
          </Grid>
          <p>
            <strong>MISE EN GARDE:</strong><br />
            Les essais rapportés dans le présent formulaire ne comprennent pas la mise à l'essai des dispositifs auxiliaires.  Par contre, lors d'une inspection des fonctions auxiliaires, la compagnie PROTECTION INCENDIE MCI inspecte le fonctionnement du relai interne au panneau de contrôle ainsi que la fonction elle-même, dans la mesure du possible lorsqu'elles sont identifiées, mais ne se tient nullement responsable de l'opéation mécanique de ladite fonction auxiliaire.
          </p>
          <p>
            De plus, la validité du certificat n'est pertinente que si aucune autre personne n'altère ou n'additionne des composantes au réseau d'alarme incendie et ce, en tout temps.  Lorsque des modifications sont à effectuer sur ledit réseau, vous devez en aviser le département de service de PROTECTION INCENDIE MCI qui effectuera les vérifications d'usage
          </p>
          <p><strong>IMPORTANT:</strong> Le présent certificat se limite aux équipements apparaissant dans le présent rapport.</p>
          <Divider />
          <TableDnD
            formEntry={equipment}
            tableProps={{ celled: true, compact: 'very', size: 'small', style: { minWidth: '800px!important' } }}
            totalRowLabel='tableRows'
            minimumRows={30}
            addRowLabel="Ajouter X nombre d'équipement supplémentaire"
            droppableKey='tableEquipmentE'
            headers={[{
              props: { style: { width: '30%' }, textAlign: 'center', verticalAlign: 'bottom' },
              key: 'eEmplacement',
              label: 'EMPLACEMENT'
            }, {
              props: { style: { width: '15%' }, textAlign: 'center', verticalAlign: 'bottom' },
              key: 'eModele',
              label: 'MODÈLE'
            }, {
              props: { style: { width: '2%' }, className: 'table-vertical', verticalAlign: 'bottom' },
              key: 'eInstalle',
              label: (<div className='table-vertical'>INSTALLÉ CONVENABLEMENT</div>)
            }, {
              props: { style: { width: '2%' }, className: 'table-vertical', verticalAlign: 'bottom' },
              key: 'eManquant',
              label: (<div className='table-vertical'>MISE À LA TERRE</div>)
            }, {
              props: { style: { width: '2%' }, className: 'table-vertical', verticalAlign: 'bottom' },
              key: 'eReparation',
              label: (<div className='table-vertical'>RÉPARATION NÉCESSAIRE</div>)
            }, {
              props: { style: { width: '2%' }, className: 'table-vertical', verticalAlign: 'bottom' },
              key: 'eFonctionnement',
              label: (<div className='table-vertical'>FONCTIONNEMENT CONFIRMÉ</div>)
            }, {
              props: { style: { width: '2%' }, className: 'table-vertical', verticalAlign: 'bottom' },
              key: 'eSupervision',
              label: (<div className='table-vertical'>SUPERVISION CONFIRMÉ</div>)
            }, {
              props: { style: { width: '2%' }, className: 'table-vertical', verticalAlign: 'bottom' },
              key: 'eSurveillance',
              label: (<div className='table-vertical'>SURVEILLANCE DU CÂBLAGE</div>)
            }, {
              props: { style: { width: '8%' }, textAlign: 'center', verticalAlign: 'bottom' },
              key: 'eDispositif',
              label: 'DISPOSITIF'
            }, {
              props: { style: { width: '8%' }, textAlign: 'center', verticalAlign: 'bottom' },
              key: 'eZone',
              label: 'ZONE OU ADRESSE'
            }, {
              props: { style: { width: '8%' }, textAlign: 'center', verticalAlign: 'bottom' },
              key: 'eDeficiences',
              label: 'DÉFICIENCES ET/OU REMARQUES (VOIR SECTIONS 1-2-3)'
            }
            ]}
            fields={[
              {
                fieldType: Input,
                props: {
                  name: 'emplacement_'
                }
              }, {
                fieldType: Input,
                props: {
                  name: 'model_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'ic_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'manquant_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'rn_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'fc_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'sc_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'sca_'
                }
              }, {
                fieldType: Select,
                props: {
                  name: 'dispositif_',
                  options: DispositifList(),
                  onBlur: this.handleUpdateRegistryFromTableCount,
                  search: true,
                  defaultValue: ''
                }
              }, {
                fieldType: Input,
                props: {
                  name: 'za_'
                }
              }, {
                fieldType: Input,
                props: {
                  name: 'defRemarque_'
                }
              }
            ]}
          />
        </Section>
        <Section title={(<Header as='h2'>DÉFICIENCES MAJEURES (SECTION #1)</Header>)}>
          <Table celled compact='very' size='small' style={{ minWidth: '800px!important' }}>
            <Table.Body>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d1' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D1</strong></Table.Cell>
                <Table.Cell>Équipement défectueux</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d2' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D2</strong></Table.Cell>
                <Table.Cell>Équipement défectueux à cause d'un problème de filage</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d3' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D3</strong></Table.Cell>
                <Table.Cell>Équipement endommagé</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d4' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D4</strong></Table.Cell>
                <Table.Cell>Les batteries sont trop faibles pour alimenter le réseau pendant la période requise</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d5' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D5</strong></Table.Cell>
                <Table.Cell>Étiquette de désignation erronée et/ou imprécise</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d6' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D6</strong></Table.Cell>
                <Table.Cell>Équipement peinturé</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d7' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D7</strong></Table.Cell>
                <Table.Cell>Équipement mal fixé</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d8' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D8</strong></Table.Cell>
                <Table.Cell>Le système installé ne répond pas à la définition d'un réseau avertisseur d'incendie (CNB 3.2.4)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d9' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D9</strong></Table.Cell>
                <Table.Cell>La centrale n'a pas reçu de signaux</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d10' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D10</strong></Table.Cell>
                <Table.Cell><Input name='text_deficience_d10' formEntry={equipment} /></Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Section>
        <Section title={(<Header as='h2'>DÉFICIENCES (SECTION #2)</Header>)}>
          <Table celled compact='very' size='small' style={{ minWidth: '800px!important' }}>
            <Table.Body>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d11' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D11</strong></Table.Cell>
                <Table.Cell>Cet équipement n'est pas installé pour son utilisation optimale (ULC S524)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d12' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D12</strong></Table.Cell>
                <Table.Cell>Le pré-signal excède la période permise (CNB 3.2.4.4)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d13' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D13</strong></Table.Cell>
                <Table.Cell>Le signal d'alarme s'arrête automatiquement avant le délai prévu par le code (CNB 3.2.4.6)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d14' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D14</strong></Table.Cell>
                <Table.Cell>L'activation du microphone arrête la signalisation pendant la première minute (CNB 3.2.4.22)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d15' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D15</strong></Table.Cell>
                <Table.Cell>Cet équipement devrait être relié sur une autre zone (CNB 3.2.4.8)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d16' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D16</strong></Table.Cell>
                <Table.Cell>Cet équipement n'est pas facilement visible et/ou accessible (CNPI 6.3.1.2)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d17' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D17</strong></Table.Cell>
                <Table.Cell>Il y a plusieurs types de sonneries lors d'une alarme incendie (CNB 3.2.4.19)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d18' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D18</strong></Table.Cell>
                <Table.Cell>Détecteur de chaleur requis (CNB 3.2.4.10)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d19' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D19</strong></Table.Cell>
                <Table.Cell>Détecteur de fumée requis (CNB 3.2.4.11)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d20' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D20</strong></Table.Cell>
                <Table.Cell>Station manuelle requise (CNB 3.2.4.17)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d21' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D21</strong></Table.Cell>
                <Table.Cell>Équipement de signalisation sonore requis (CNB 3.2.4.19)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d22' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D22</strong></Table.Cell>
                <Table.Cell>Équipement de signalisation visuel requis (CNB 3.2.4.19)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d23' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D23</strong></Table.Cell>
                <Table.Cell>Ce système doit être relié à une centrale de surveillance (CNB 3.2.4.7)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d24' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D24</strong></Table.Cell>
                <Table.Cell>Il n'y a pas de panneau annonciateur à cette entrée du bâtiment (CNB 3.2.4.8)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d25' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D25</strong></Table.Cell>
                <Table.Cell>Le système de gicleurs n'est pas entièrement sous surveillance électrique (CNB 3.2.4.9)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d26' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D26</strong></Table.Cell>
                <Table.Cell>La signatlisation d'alarme ne s'entend pas adéquatement à cet endroit (CNB 3.2.4.19)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d27' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D27</strong></Table.Cell>
                <Table.Cell>Les portes des issues restent vérouillées lors d'une alarme (CNB 3.4.6.15)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d28' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D28</strong></Table.Cell>
                <Table.Cell>Les portes coupe-feu ne se ferment pas lors d'une alarme (CNB 3.1.8.12)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d29' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D29</strong></Table.Cell>
                <Table.Cell>La hotte de cuisine n'est pas reliée au système (NFPA #96 10.6.2)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d30' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D30</strong></Table.Cell>
                <Table.Cell>Les batteries de secours ne sont pas assez fortes pour la durée requise (CNB 3.2.7.8)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d31' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D31</strong></Table.Cell>
                <Table.Cell>Cette supervision ne se vérouille pas (ULC S-524 5.3.3)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d32' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D32</strong></Table.Cell>
                <Table.Cell>Cette supervision donne un signal identique au bris de fils lors de son activation (ULC-S524 5.3.5)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d33' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D33</strong></Table.Cell>
                <Table.Cell>Le détecteur de gaine n'arrête pas la ventilation (CNB 3.2.4.12)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d34' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D34</strong></Table.Cell>
                <Table.Cell>L'ascenseur demeure en fonction lors d'une alarme (CNB 3.2.4.14)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d35' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D35</strong></Table.Cell>
                <Table.Cell>L'ascenseur n'est pas renvoyé sur un palier alternatif (CNB 3.2.4.14)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d36' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D36</strong></Table.Cell>
                <Table.Cell>Le dispositif de sécurité (tamper) à priorité sur le signal de l'équipement (ULC S-524 5.3.9 et 10)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d37' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D37</strong></Table.Cell>
                <Table.Cell><Input name='text_deficience_d37' formEntry={equipment} /></Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d38' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D38</strong></Table.Cell>
                <Table.Cell><Input name='text_deficience_d38' formEntry={equipment} /></Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d39' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D39</strong></Table.Cell>
                <Table.Cell><Input name='text_deficience_d39' formEntry={equipment} /></Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Section>
        <Section title={(<Header as='h2'>REMARQUES (SECTION #2)</Header>)}>
          <Table celled compact='very' size='small' style={{ minWidth: '800px!important' }}>
            <Table.Body>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r1' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R1</strong></Table.Cell>
                <Table.Cell>Nous avons seulement effectué une vérification aux bornes de raccordement de cet équipement</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r2' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R2</strong></Table.Cell>
                <Table.Cell>Nous n'avons pas eu accès à ce local</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r3' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R3</strong></Table.Cell>
                <Table.Cell>Cet équipement est inaccessible</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r4' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R4</strong></Table.Cell>
                <Table.Cell>Nous n'avons pas localisé cet équipement</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r5' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R5</strong></Table.Cell>
                <Table.Cell>Cet équipement n'a pas été mis à l'essai depuis 3 ans ou plus</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r6' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R6</strong></Table.Cell>
                <Table.Cell>Ce détecteur est à déclenchement unique</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r7' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R7</strong></Table.Cell>
                <Table.Cell>Un technicien de gicleur est requis pour inspecter cet équipement</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r8' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R8</strong></Table.Cell>
                <Table.Cell>Un technicien d'ascenseur est requis pour inspecter cet équipement</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r9' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R9</strong></Table.Cell>
                <Table.Cell>Un technicien de la génératrice est requis pour inspecter cet équipement</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r10' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R10</strong></Table.Cell>
                <Table.Cell>Un technicien de système automatique de cuisine est requis pour inspecter cet équipement</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r11' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R11</strong></Table.Cell>
                <Table.Cell>Un technicien du système d'extinction est requis pour inspecter cet équipement</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r12' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R12</strong></Table.Cell>
                <Table.Cell>Les essais mentionnés aux articles 5,8,4,1,3 n'ont pas été effectués</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r13' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R13</strong></Table.Cell>
                <Table.Cell>La sensibilité indiquée dans la colonne ''note'' est cette founi par le panneau</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r14' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R14</strong></Table.Cell>
                <Table.Cell>L'analyseur de batterie est inférieur à 70%, mais supérieur à 60%, il faudra prévoir leurs remplacements lors de la prochaine inspection</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r15' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R15</strong></Table.Cell>
                <Table.Cell>La résistance de F.D.L. est installée dans l'équipement</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r16' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R16</strong></Table.Cell>
                <Table.Cell><Input name='text_remarque_r16' formEntry={equipment} /></Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r17' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R17</strong></Table.Cell>
                <Table.Cell><Input name='text_remarque_r17' formEntry={equipment} /></Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r18' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R18</strong></Table.Cell>
                <Table.Cell><Input name='text_remarque_r18' formEntry={equipment} /></Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r19' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R19</strong></Table.Cell>
                <Table.Cell><Input name='text_remarque_r19' formEntry={equipment} /></Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Section>
        <Section title={(<Header as='h2'>REMARQUES INTERNES AUX TECHNICIENS ET/OU BUREAU</Header>)}>
          <Table celled compact='very' size='small' style={{ minWidth: '800px!important' }}>
            <Table.Body>
              {[...Array(32)].map((row, index) => (
                <Table.Row key={`tableRowExL${index + 1}`}>
                  <Table.Cell><Input name={`text_remarqueInterne_${index + 1}`} formEntry={equipment} /></Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Section>
      </Form>
    )
  }
}
export default RIA537000E
